import {createContext} from "react";
import {FeedbackContextValue} from "./FeedbackContextValue";

export const FeedbackContext = createContext<FeedbackContextValue>([
  undefined,
  () => {}
]);
